(() => {
  // Preview another color's photo on the card while a swatch is hovered or focused.
  const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const imageFor = (link) => link.closest('.g-collection-card')?.querySelector('.g-collection-card__media img');
  const show = (link) => {
    const image = imageFor(link);
    if (!image || !link.dataset.gSwatchImage) return;
    if (!image.dataset.gSwatchOriginal) {
      image.dataset.gSwatchOriginal = image.getAttribute('src') || '';
      image.dataset.gSwatchOriginalSrcset = image.getAttribute('srcset') || '';
    }
    image.setAttribute('srcset', link.dataset.gSwatchSrcset || link.dataset.gSwatchImage);
    image.setAttribute('src', link.dataset.gSwatchImage);
  };
  const restore = (link) => {
    const image = imageFor(link);
    if (!image || image.dataset.gSwatchOriginal === undefined) return;
    if (image.dataset.gSwatchOriginalSrcset) image.setAttribute('srcset', image.dataset.gSwatchOriginalSrcset);
    else image.removeAttribute('srcset');
    image.setAttribute('src', image.dataset.gSwatchOriginal);
  };
  const swatchFrom = (event) => event.target instanceof Element ? event.target.closest('a.g-swatch') : null;
  document.addEventListener('pointerover', (event) => { const link = swatchFrom(event); if (link && fineHover.matches) show(link); });
  document.addEventListener('pointerout', (event) => { const link = swatchFrom(event); if (link && !link.contains(event.relatedTarget)) restore(link); });
  document.addEventListener('focusin', (event) => { const link = swatchFrom(event); if (link) show(link); });
  document.addEventListener('focusout', (event) => { const link = swatchFrom(event); if (link) restore(link); });
})();
